module.exports = __webpack_public_path__ + "media/uk_ua_s2_Veronika.05e8bd08.mp3";